import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const ggpFields = [
  "statecode", // number
  "statuscode", // number
  "gaming_webformsubmissiondate", // Date
  "ggp_strikeid", // UID
  "gaming_pitchid", // Text
  "ggp_accountid", // UID
  "gaming_pitchsubmissionsource",
  "gaming_pitchstatus", // Pitch status
  "gaming_SubmittedByContactId", // Lookup - Contact
  "gaming_HubLastUpdateByContactId", // Lookup - Contact
  "ggp_name", // Text
  // Publisher developer information
  "gaming_companynamesubmitted",
  "gaming_submitter",
  "gaming_xboxreferral",
  "gaming_prospectiveprograms",
  "gaming_prospectiveprogramsother",
  "gaming_pitchjustification",
  "gaming_prototypefundingdetails",
  "gaming_studiosize",
  "gaming_studiopointofcontact",
  "gaming_prototypefundingdetails",
  "gaming_companycountry",
  "gaming_havepublisher",
  "gaming_publishernamememo",
  "gaming_developername",
  "gaming_studioestablisheddate",
  "ggp_pitchdecklink",
  "gaming_website",
  "gaming_alreadyidxbox",
  "gaming_havedevkitpick",
  "gaming_launchedforconsole",
  "gaming_gameslaunchedforconsole",
  "gaming_contentvalidationstatus",
  /*
  About your game
  */
  "gaming_gametitle", // Text
  "gaming_blockchainornftpick", // picklist
  "gaming_developmentstage", // picklist
  "gaming_releasedforotherplatforms", // picklist
  "gaming_releasedplatforms", // multiselect
  "gaming_releasedplatformsother", // Text
  "gaming_releasedplatformsdate", // Datetime
  "gaming_announced", // picklist
  "gaming_targetedplatforms", // Multiselect
  "gaming_othertargetedplatforms", // Picklist
  "gaming_steamreleasewindow", // Text
  "gaming_xboxreleasewindow", // Text
  "gaming_genre", // multiselect
  "gaming_prospectingengine", // Picklist
  "gaming_businessmodels", // Multipick
  "gaming_prospectingengine",
  "gaming_genreother", // Picklist
  "gaming_engineother", // Text
  "gaming_gameplayduration", // Text
  "gaming_onlinemultiplayer", // Picklist
  "gaming_gamepitchdecklink", // Text
  "gaming_otherinfolinks", // Text
  "ggp_demobuildlink", // Text
  "ggp_trailerlink", // Text
  "gaming_gamedescription", // Text
  "gaming_targetaudience", // Text
  "gaming_competitortitles", // Text
  "gaming_uniquefactor", // Text
  "gaming_feelingsevoked", // Text
  "gaming_pivotalmoment", // Text
  "gaming_postlaunchsupportplans", // Text
  "gaming_sensitivecontent", // picklist
  "gaming_sensitivecontentdetails", // text
  /*
    Ask for Xbox
  */
  "gaming_fundingsoughtpick", // Text
  "gaming_fundingsoughtdetails", // Text
  "gaming_othersupportneeded", // Text
  /*
    About Yourself
  */
  "gaming_studiobackground", // Text
  "gaming_activeinlocalgamedevcommunity", // Text
] as const;

export const strikeConceptReferences: EntityReferences<EntityName.ggp_strike> = {
  [EntityName.account]: ["ggp_accountid"],
  [EntityName.contact]: ["gaming_SubmittedByContactId", "gaming_HubLastUpdateByContactId"],
};

export const strikeConceptKey: AnyEntityField<EntityName.ggp_strike> = "ggp_strikeid";
